import * as React from 'react';
import { IndexRedirect, IndexRoute, Route } from 'react-router';

import CurriculumBuilder from 'bundles/internal-enterprise/components/CurriculumBuilder';
import CurriculumManager from 'bundles/internal-enterprise/components/CurriculumManager';
import EnterpriseApp from 'bundles/internal-enterprise/components/EnterpriseApp';
import EnterpriseProgramBulkAdd from 'bundles/internal-enterprise/components/EnterpriseProgramBulkAdd';
import EnterpriseProgramDownload from 'bundles/internal-enterprise/components/EnterpriseProgramDownload';
import EnterpriseProgramInvitation from 'bundles/internal-enterprise/components/EnterpriseProgramInvitation';
import EnterpriseProgramLookup from 'bundles/internal-enterprise/components/EnterpriseProgramLookup';
import EnterpriseToolsHome from 'bundles/internal-enterprise/components/EnterpriseToolsHome';
import InternalThirdPartyOrganizationPage from 'bundles/internal-enterprise/components/InternalThirdPartyOrganizationPage';
import AcademicIntegrity from 'bundles/internal-enterprise/components/InternalThirdPartyOrganizationPage/AcademicIntegrity';
import AutoEnrollmentSettings from 'bundles/internal-enterprise/components/InternalThirdPartyOrganizationPage/AutoEnrollmentSettings';
import DataProtection from 'bundles/internal-enterprise/components/InternalThirdPartyOrganizationPage/DataProtection';
import PlagiarismEmails from 'bundles/internal-enterprise/components/InternalThirdPartyOrganizationPage/PlagiarismEmails';
import PrivateAuthoring from 'bundles/internal-enterprise/components/InternalThirdPartyOrganizationPage/PrivateAuthoring';
import ProgramManagerWithMemberships from 'bundles/internal-enterprise/components/ProgramManagerWithMemberships';
import SelfServeContentTool from 'bundles/internal-enterprise/components/SelfServeContentTool';
import ThirdPartyOrganizationsHome from 'bundles/internal-enterprise/components/ThirdPartyOrganizationsHome';
import UserMembershipsRouteHandler from 'bundles/internal-enterprise/components/UserMembershipsRouteHandler';
import EnterpriseLeadInvoiceForm from 'bundles/internal-enterprise/components/lead/EnterpriseLeadInvoiceForm';
import EnterpriseLeadInvoicePreview from 'bundles/internal-enterprise/components/lead/EnterpriseLeadInvoicePreview';
import EnterpriseLeadSearch from 'bundles/internal-enterprise/components/lead/EnterpriseLeadSearch';
import EnterpriseLeadTool from 'bundles/internal-enterprise/components/lead/EnterpriseLeadTool';
import EnterpriseTriggerContainer from 'bundles/internal-enterprise/components/trigger/EnterpriseTriggerContainer';
import EnterpriseTriggersHome from 'bundles/internal-enterprise/components/trigger/EnterpriseTriggersHome';
import EnterpriseTriggersOrganization from 'bundles/internal-enterprise/components/trigger/EnterpriseTriggersOrganization';
import NotFound from 'bundles/phoenix/components/NotFound';

export default (
  <Route path="/internal/enterprise" component={EnterpriseApp}>
    <IndexRoute component={EnterpriseToolsHome} />
    <Route path="organizations" component={ThirdPartyOrganizationsHome} />
    <Route path="organizations/:thirdPartySlug" component={InternalThirdPartyOrganizationPage}>
      <Route path="data-protection" component={DataProtection} />
      <Route path="academic-integrity" component={AcademicIntegrity} />
      <Route path="auto-enrollment" component={AutoEnrollmentSettings} />
      <Route path="private-authoring" component={PrivateAuthoring} />
      <Route path="plagiarism-emails" component={PlagiarismEmails} />
      <IndexRedirect to="data-protection" />
    </Route>
    <Route path="email/:learnerEmailAddr" component={EnterpriseToolsHome} />
    <Route path="trigger" component={EnterpriseTriggerContainer}>
      <Route path="program" component={EnterpriseTriggersHome} />
      <Route path="organization" component={EnterpriseTriggersOrganization} />
    </Route>
    <Route path="invitation" component={EnterpriseProgramInvitation} />
    <Route path="program-lookup" component={EnterpriseProgramLookup} />
    <Route path="program-download" component={EnterpriseProgramDownload} />
    <Route path="program-bulk-add" component={EnterpriseProgramBulkAdd} />
    <Route path="curriculum-builder" component={CurriculumBuilder} />
    <Route path="self-serve" component={SelfServeContentTool} />
    <Route path="lead" component={EnterpriseLeadTool}>
      <Route path="search" component={EnterpriseLeadSearch} />
      <Route path="invoice/:leadId" component={EnterpriseLeadInvoiceForm} />
      <Route path="invoice-preview/:leadId" component={EnterpriseLeadInvoicePreview} />
      <IndexRedirect to="search" />
    </Route>
    <Route path="user">
      <Route path=":userId" component={UserMembershipsRouteHandler}>
        <Route path="memberships" component={ProgramManagerWithMemberships} />
        <Route path="curriculum" component={CurriculumManager} />
      </Route>
    </Route>
    <Route path="*" component={NotFound} />
  </Route>
);
